import {FC, useState, useEffect, Fragment} from 'react'

import {Modal} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import Api from '../../../thesis-and-dissertations/helpers/api'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import {toast} from 'react-toastify'
const api = new Api()

type Props = {
  showAlertModal: boolean
}

const AlertContent: FC<Props> = ({showAlertModal}) => {
  const navigate = useNavigate()
  const [showModal, setShowModal] = useState<any>(false)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setShowModal(showAlertModal)
  }, [showAlertModal])

  const handleOk = () => {
    localStorage.setItem('showAnnouncementModal', '0')
    navigate('/my-pana')
  }

  return (
    <Modal show={showModal} centered size='lg'>
      <div className='p-10'>
        <img
          src={require('../../assets/img/announcment-image.png')}
          alt='PANA'
          style={{height: 'auto', width: '100%'}}
        />

        <p className='h1 mt-5'>📣 Informasi Terbaru Program Pengabdian Alumni (PANA) LPDP</p>

        <p className='h6 fw-normal'>Cek sekarang!</p>

        <button
          className='btn btn-primary w-100 mt-6 fw-bold'
          style={{background: 'var(--Primary-L-500, #F95E2F)'}}
          onClick={handleOk}
          disabled={loading}
        >
          {loading === true ? 'Loading...' : 'Klik di sini untuk melihat informasi terbaru.'}
        </button>
      </div>
    </Modal>
  )
}

const AnnouncementModal: FC<Props> = ({showAlertModal}) => {
  return <AlertContent showAlertModal={showAlertModal} />
}

export default AnnouncementModal
